module.exports = __webpack_public_path__ + "static/media/sim_thumb_home.f41a730b.jpg";